export const customerManagementRouter = [
  {
    path: "/signatures/customer-management/list",
    name: "signatures-customer-management",
    meta: { title: "客户管理" },
    component: () => import("@/views/signatures/customer-management/list/index.vue"),
  },
  {
    path: "/signatures/customer-management-staff/list",
    name: "signatures-customer-management-staff",
    meta: { title: "员工授权管理" },
    component: () => import("@/views/signatures/customer-management/staff-list/index.vue"),
  }
];
